import { configureStore } from "@reduxjs/toolkit";
import appReducer from "./reducers/appSlice";
import authReducer from "./reducers/authSlice";
import orgReducer from "./reducers/organizationSlice";
// import incidentReducer from "./reducers/incidentSlice";
import adminWasteReducer from "./reducers/adminWastestatSlice";
import agenciesReducer from "./reducers/agenciesSlice";
import aggregatorReducer from "./reducers/aggregatorSlice";
import areaReducer from "./reducers/areaSlice";
import billingReducer from "./reducers/billingSlice";
import companyWasteReducer from "./reducers/companyWasteStatsSlice";
import dashboardReducer from "./reducers/dashboardSlice";
import dropOffReducer from "./reducers/dropOffSlice";
import dropoffLocation from "./reducers/dropoffLocationsSlice";
import financialsReducer from "./reducers/financialSlice";
import geoFenceReducer from "./reducers/geoFenceSlice";
import locationReducer from "./reducers/locationSlice";
import organisationReducer from "./reducers/organisationsSlice";
import paymentReducer from "./reducers/paymentSlice";
import raffleReducer from "./reducers/raffleSlice";
import reportReducer from "./reducers/reportSlice";
import resourceReducer from "./reducers/resourceSlice";
import responderReducer from "./reducers/responderSlice";
import roleReducer from "./reducers/roleSlice";
import schedulesReducer from "./reducers/schedulesSlice";
import spaceReducer from "./reducers/spaceOwnerSlice";
import userAgencyLocationReducer from "./reducers/userAgencyLocationSlice";
import userReducer from "./reducers/userSlice";
import wasteCategoryReducer from "./reducers/wasteCategorySlice";
import wasteCollectionReducer from "./reducers/wasteCollectionSlice";
import wastePickerReducer from "./reducers/wastePickerSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    app: appReducer,
    org: orgReducer,
    // incident: incidentReducer,
    responder: responderReducer,
    location: locationReducer,
    agencies: agenciesReducer,
    role: roleReducer,
    wasteCategory: wasteCategoryReducer,
    user: userReducer,
    dashboard: dashboardReducer,
    dropOff: dropOffReducer,
    schedules: schedulesReducer,
    aggregators: aggregatorReducer,
    payments: paymentReducer,
    area: areaReducer,
    collector: wasteCollectionReducer,
    organisation: organisationReducer,
    geoFence: geoFenceReducer,
    companyWaste: companyWasteReducer,
    adminWaste: adminWasteReducer,
    raffle: raffleReducer,
    report: reportReducer,
    resource: resourceReducer,
    dropoffLocation: dropoffLocation,
    userAgencyLocation: userAgencyLocationReducer,
    pickers: wastePickerReducer,
    financials: financialsReducer,
    billing: billingReducer,
    spaceOwner: spaceReducer,
  },
});

export default store;
